import { BaseEntity } from './base-entity.model';
import { Language } from './language.interface';

export abstract class TranslatedEntity<T> extends BaseEntity<T> {
  language?: Language;
}
